@let selected = selectedOption();

<mat-select
  [value]="value()"
  (selectionChange)="onSelectionChange($event.value)"
  [panelClass]="'engagement-contact-select-panel'"
  [hideSingleSelectionIndicator]="true"
  disableRipple
>
  <!-- Custom trigger: shows selected contact with avatar -->
  <mat-select-trigger>
    @if (selected) {
      <div class="contact-trigger">
        <span class="contact-avatar" [attr.data-initials]="selected.initials">
          {{ selected.initials }}
        </span>
        <div class="contact-info">
          <span class="contact-name">{{ selected.name }}</span>
          <span class="contact-email">{{ selected.email }}</span>
        </div>
      </div>
    }
  </mat-select-trigger>

  <!-- Panel header -->
  <div class="contact-panel-header">SWITCH ACCOUNT</div>

  <!-- Options -->
  @for (option of options(); track option.contactId) {
    <mat-option [value]="option.contactId">
      <div class="contact-option">
        <span class="contact-avatar" [attr.data-initials]="option.initials">
          {{ option.initials }}
        </span>
        <div class="contact-info">
          <span class="contact-name">{{ option.name }}</span>
          <span class="contact-email">{{ option.email }}</span>
        </div>
      </div>
    </mat-option>
  }
</mat-select>
